import { render, staticRenderFns } from "./zcwj.vue?vue&type=template&id=0b95a331&scoped=true&"
import script from "./zcwj.vue?vue&type=script&lang=js&"
export * from "./zcwj.vue?vue&type=script&lang=js&"
import style0 from "./zcwj.vue?vue&type=style&index=0&id=0b95a331&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95a331",
  null
  
)

export default component.exports